/**
 * firebaseの設定ファイル
 * https://www.pluralsight.com/guides/using-firebase-with-react-and-redux
 */

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyAxwtUKEOBuSwA2vxbEShREqaNzELQ3DiQ",
  authDomain: "makemyroomclean-23d2e.firebaseapp.com",
	databaseURL: "https://makemyroomclean-23d2e-default-rtdb.firebaseio.com/",
  projectId: "makemyroomclean-23d2e",
  storageBucket: "makemyroomclean-23d2e.appspot.com",
  messagingSenderId: "67592845411",
  appId: "1:67592845411:web:44cf1bea187b9783a22056",
  measurementId: "G-S6ZCXKV3RX"
};